import { useAllBlueSpacesQuery } from '../graphql/blueSpaces'
import Map from '../components/Map'

function FullPageMap() {
  const { blueSpaces } = useAllBlueSpacesQuery()

  return (
    <Map blueSpaces={ blueSpaces } height="100vh" withButton={ false } target="_parent" interfaceColor="white" />
  )
}

export default FullPageMap
